import React from 'react';
import { Col, Row } from '../../../lib/utils';
import { Head4, Body2Bold, Body3Regular, CaptionRegular } from '../../../lib/font';
import { colors } from '../../../lib/colors';
import { PaymentRequest, formatPrice } from '../data/dummyData';

interface TicketInfoCardProps {
    data: PaymentRequest;
    showPrice?: boolean;
}

const InfoRow: React.FC<{ label: string; value: string }> = ({ label, value }) => (
    <Row style={{ justifyContent: 'space-between', alignItems: 'center', padding: '10px 0' }}>
        <CaptionRegular style={{ color: colors.LAVEL_2 }}>{label}</CaptionRegular>
        <Body3Regular style={{ color: colors.LAVEL_4, fontWeight: 500 }}>{value}</Body3Regular>
    </Row>
);

const TicketInfoCard: React.FC<TicketInfoCardProps> = ({ data, showPrice = true }) => {
    return (
        <Col
            style={{
                width: '100%',
                backgroundColor: '#FFFFFF',
                borderRadius: 16,
                padding: '24px 20px',
                boxShadow: '0 2px 12px rgba(0, 0, 0, 0.06)',
            }}
        >
            <CaptionRegular style={{ color: colors.LAVEL_2 }}>
                {data.ticketType} · {data.paymentType === 'PREPAY' ? '선결제' : '수업마다 결제'}
            </CaptionRegular>
            <Body2Bold style={{ color: colors.LAVEL_4, marginTop: 4 }}>{data.ticketName}</Body2Bold>

            {showPrice && (
                <Head4 style={{ color: colors.primary, marginTop: 12 }}>
                    {formatPrice(data.paymentType === 'PREPAY' ? data.totalPrice : data.perSessionPrice)}원
                    {data.paymentType === 'PER_SESSION' && (
                        <CaptionRegular style={{ color: colors.LAVEL_2, marginLeft: 4 }}> / 1회</CaptionRegular>
                    )}
                </Head4>
            )}

            <div style={{ width: '100%', height: 1, backgroundColor: '#F0F0F0', margin: '16px 0' }} />

            {data.paymentType === 'PREPAY' && (
                <InfoRow label="결제 금액" value={`${formatPrice(data.totalPrice)}원`} />
            )}
            {data.paymentType === 'PER_SESSION' && (
                <>
                    <InfoRow label="1회 수업료" value={`${formatPrice(data.perSessionPrice)}원`} />
                    <InfoRow label="총 금액 (참고)" value={`${formatPrice(data.totalPrice)}원`} />
                </>
            )}
            <InfoRow label="횟수 / 기간" value={`${data.sessionCount}회 / ${data.durationMonths}개월`} />
            <InfoRow label="담당 트레이너" value={`${data.trainerName}`} />
            <InfoRow label="이용 시작일" value={data.startDate} />
            <InfoRow label="이용 종료일" value={data.endDate} />
        </Col>
    );
};

export default TicketInfoCard;
